import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";

export function B18({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XSSTR01.error_id: {
            return (
                <>
                    <ResultText>
                        {
                            row?.data?.map(r => {
                                const sections = []
                                if(r.section4)
                                    sections.push('#4')
                                if(r.section3)
                                    sections.push('#3')
                                if(r.section2)
                                    sections.push('#2')
                                if(r.section1)
                                    sections.push('#1')

                                return (
                                    <>
                                        The {r?.type} at RS {<CheckCSName csName={r?.cross_section} />} is missing Section {sections.join(', ')}.
                                        <EmptyLine />
                                    </>
                                )
                            })
                        }
                    </ResultText>
                </>
            )
        }
    }
}